export default __webpack_public_path__ + "static/media/image00035.2ebc0b26.jpeg";